import { observable, action, runInAction } from 'mobx';
import { get } from '../../utils/fetch';
import { errorHandler } from '../../utils/methods';
import { backendServer } from '../../variable';

class AboutUs {
  @observable
  protocol = []; //协议

  @action
  fetchProtocol = async params => {
    //获取协议
    try {
      const response = await get(`${backendServer}/aboutUs/getFilePath`);
      if (response.success) {
        runInAction(() => {
          this.protocol = response.data;
        });
      } else {
        errorHandler(response);
      }
    } catch (error) {
      errorHandler(error, '获取协议');
    }
  };
}

export default new AboutUs();



// WEBPACK FOOTER //
// ./src/stores/aboutUs/index.js